module.exports = __webpack_public_path__ + "static/left-tree-4d602c70fc93ed19dd111e6e44817a9b.png";